import React from 'react'
import { ServicesContainer,ServicesH1,ServicesWrapper,ServicesCard,ServicesIcon,ServicesH2,ServicesP,ProjectBtn,ProjectLink } from './ServicesElements'
import Icon1 from '../../images/svg-4.svg'
import Icon2 from '../../images/svg-3.svg'
import Icon3 from '../../images/svg-6.svg'


const Services = () => {
    return (
        <>
            <ServicesContainer id="services">
                <ServicesH1>Our Services</ServicesH1>
                <ServicesWrapper>
                    <ServicesCard>
                        <ServicesIcon src={Icon1} />
                        <ServicesH2>Learn about New Tech</ServicesH2>
                        <ServicesP>Get knowledge about new technology being used Now a days</ServicesP>
                    </ServicesCard>
                    <ServicesCard>
                        <ServicesIcon src={Icon2} />
                        <ServicesH2>Virtually connected</ServicesH2>
                        <ServicesP>Not only see the products, apps and tech, But also implement the Knowledge gained with the Phoenix family.</ServicesP>
                    </ServicesCard>
                    <ServicesCard>
                        <ServicesIcon src={Icon3} />
                        <ServicesH2>Build Projects</ServicesH2>
                        <ServicesP>Projects are a plus if you are a good learner.This helps in building your Portfolio too</ServicesP>
                    </ServicesCard>

                </ServicesWrapper>
                <ProjectBtn>
                    <ProjectLink href='//connecting-fox.web.app'>Chat with us</ProjectLink>
                </ProjectBtn>
            </ServicesContainer>

        </>
    )
}

export default Services
